<template>
    <div class="map-nav" :class="[rootClasses]">
        <button class="u-reset map-nav--backdrop" aria-hidden="true"
                v-if="mapNav.isActive"
                @click="toggleActive(false)">
        </button>

        <div v-if="showPartial" class="map-nav--wrap">
            <button type="button" class="map-nav--toggle"
                    :style="[isMobile ? scrollLockStyles : {}]"
                    @click="toggleActive()">
                <span class="map-nav--toggle-wrap">
                    <span class="map-nav--toggle-text" v-text="partial.dropdown.title"></span>
                    <cmp-icon class="map-nav--toggle-icon" symbol="chevron-down" size="small"></cmp-icon>
                </span>
            </button>

            <transition name="trs-simple-fade">
                <button type="button" class="map-nav--sorter"
                        :style="[isMobile ? scrollLockStyles : {}]"
                        v-if="mapNav.isActive"
                        @click="toggleSort()">
                    <span class="map-nav--sorter-wrap">
                        <span class="map-nav--sorter-title"
                                v-text="partial.dropdown.sort_title">
                        </span>
                        <span class="map-nav--sorter-indicator">
                            <span class="map-nav--sorter-indicator-text"
                                    v-text="partial.dropdown.sort_label">
                            </span>
                        </span>
                    </span>
                </button>
            </transition>

            <cmp-accordion class="map-nav--accordion" :is-active="mapNav.isActive" :passive-mode="true">
                <!-- body -->
                <template slot="body" slot-scope="props">
                    <div class="map-nav--content">
                        <div class="map-nav--list">
                            <ul class="u-reset map-nav--locations">
                                <li class="map-nav--location"
                                        v-for="(loc, locIdx) in locations" :key="loc.link">
                                    <router-link class="u-reset map-nav--location-link" :to="loc.link"
                                            @click="toggleActive(false)">
                                        <span class="map-nav--location-link-text"
                                                v-text="loc.name">
                                        </span>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </template>
            </cmp-accordion>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import bemMixin from 'framework/mixins/bem';
    import isMobileMixin from 'framework/mixins/is-mobile';
    import cmsPartialMixin from 'framework/mixins/cms/cms-partial';
    import scrollLockHelperMixin from 'framework/mixins/scroll-lock-helper';


    export default {
        mixins: [
            bemMixin('map-nav'),
            isMobileMixin,
            cmsPartialMixin,
            scrollLockHelperMixin,
        ],
        props: {
            partialName: {
                type: String,
                default: 'map',
            },
        },
        data() {
            return {
                scrollLockHelperStyleProp: 'border-right-width',
                isSorted: false,
            };
        },
        computed: {
            ...mapGetters(['mapNav']),
            rootClasses() {
                return [
                    this.bemFacet,
                    this.bemAdd(this.mapNav.isActive ? 'is-active' : ''),
                    this.bemAdd(this.isSorted ? 'is-sorted' : 'is-unsorted'),
                ];
            },
            locations() {
                return this.isSorted ? this.sortedLocations : this.partial.locations;
            },
            sortedLocations() {
                return this.partial.locations
                    .concat()
                    .sort(({ name: nameA }, { name: nameB }) => {
                        let result = 0;
                        const a = nameA.toLowerCase();
                        const b = nameB.toLowerCase();

                        if (a < b) {
                            result = -1;
                        }

                        if (a > b) {
                            result = 1;
                        }

                        return result;
                    });
            },
        },
        methods: {
            ...mapActions(['toggleMapNav']),
            toggleActive(toggle) {
                document.activeElement.blur();
                this.toggleMapNav({
                    toggle: (toggle == null ? !this.mapNav.isActive : !!toggle),
                });
            },
            toggleSort(toggle) {
                document.activeElement.blur();
                this.isSorted = (toggle == null ? !this.isSorted : !!toggle);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/map-nav/index.vue?2e777af8